import { updateSellerSettingsBulk } from '../pages/settings/api/save-settings';
import { SellerSettings } from '../enums/seller-settings/seller-settings';

export type BuyNowSetting = {
  optedInToBuyNow: boolean;
  isBuyNowFlowCompleted: boolean;
};

/**
 * Service for managing Buy Now flow state via seller settings
 */
export const BuyNowService = {
  /**
   * Marks the Buy Now flow as completed for the authenticated seller.
   * Must preserve optedInToBuyNow value from current setting.
   */
  async markFlowCompleted(currentSetting: BuyNowSetting | undefined): Promise<BuyNowSetting> {
    const updatedSetting: BuyNowSetting = {
      optedInToBuyNow: currentSetting?.optedInToBuyNow ?? false,
      isBuyNowFlowCompleted: true,
    };

    await updateSellerSettingsBulk({
      [SellerSettings.isBuyNow.key]: updatedSetting,
    });

    return updatedSetting;
  },
};
